import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useStripLngQueryParam(): void {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.has('lng')) return;
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete('lng');
        return next;
      },
      { replace: true },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deliberado (D2/D4, design.md):
    // se ejecuta una sola vez al montar. No depende de `searchParams` en el array de deps
    // porque `setSearchParams` ya actualiza `searchParams` en el siguiente render, y ese
    // propio cambio no debe disparar una segunda pasada.
  }, []);
}
